import { gql } from '@apollo/client'

export const GET_ALL_CATEGORIES_QUERY = gql`
  query AllSubCategoriesForStars($categoryId: ID!) {
    allCategories: childCategoriesWithRelations(
      relationWith: ["artist"]
      isSearchable: true
      categoryId: $categoryId
    ) {
      edges {
        node {
          id
          name
          position
          starcategorySet(isSearchable: true) {
            edges {
              node {
                id
                name
                position
                starcategorySet(isSearchable: true) {
                  edges {
                    node {
                      id
                      name
                      position
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`

export const ALL_CATEGORIES = gql`
  query AllCategories(
    $useConcert: Boolean!
    $useComedy: Boolean!
    $useSport: Boolean!
    $concertCategoryId: ID!
    $comedyCategoryId: ID!
    $sportCategoryId: ID!
  ) {
    concerts: childCategoriesWithRelations(
      categoryId: $concertCategoryId
      relationWith: ["artist"]
      isSearchable: true
    ) @include(if: $useConcert) {
      edges {
        node {
          id
          isSearchable
          name
          starcategorySet(isSearchable: true) {
            edges {
              node {
                id
                name
                starcategorySet(isSearchable: true) {
                  edges {
                    node {
                      id
                      name
                    }
                  }
                }
              }
            }
          }
          image {
            id
            path
            extension
          }
          position
          parent {
            id
            name
          }
        }
      }
    }
    sports: childCategoriesWithRelations(
      categoryId: $sportCategoryId
      relationWith: ["artist"]
      isSearchable: true
    ) @include(if: $useSport) {
      edges {
        node {
          id
          isSearchable
          name
          starcategorySet(isSearchable: true) {
            edges {
              node {
                id
                name
                starcategorySet(isSearchable: true) {
                  edges {
                    node {
                      id
                      name
                    }
                  }
                }
              }
            }
          }
          image {
            id
            path
            extension
          }
          position
          parent {
            id
            name
          }
        }
      }
    }
    comedy: childCategoriesWithRelations(
      categoryId: $comedyCategoryId
      relationWith: ["artist"]
      isSearchable: true
    ) @include(if: $useComedy) {
      edges {
        node {
          id
          isSearchable
          name
          starcategorySet(isSearchable: true) {
            edges {
              node {
                id
                name
                starcategorySet(isSearchable: true) {
                  edges {
                    node {
                      id
                      name
                    }
                  }
                }
              }
            }
          }
          image {
            id
            path
            extension
          }
          position
          parent {
            id
            name
          }
        }
      }
    }
  }
`

export const GET_CITIES = gql`
  query GetCities(
    $id: ID
    $first: Int
    $after: String
    $orderBy: String
    $coordinates: String
    $name: String
    $status: String
    $coordinatesSort: String
  ) {
    allCities(
      id: $id
      first: $first
      after: $after
      orderBy: $orderBy
      coordinates: $coordinates
      name_Icontains: $name
      status: $status
      coordinatesSort: $coordinatesSort
    ) {
      edges {
        node {
          id
          pk
          name
          stateCode
          lat
          lon
        }
      }
    }
  }
`

export const GET_AUTOMATIC_APPLY_PROMOCODE = gql`
  query getAutomaticApplyPromocode {
    automaticApplyPromocode {
      id
      code
    }
  }
`

export const FIND_USER_REFERRAL = gql`
  query UserReferral($code: String!) {
    findUserReferral(code: $code) {
      id
    }
  }
`

export const GET_CREDIT_ACTION_TYPES = gql`
  query GetCreditActionTypes($id: ID) {
    creditActionTypes(id: $id) {
      edges {
        node {
          id
          pk
          type
          amount
          createdAt
          updatedAt
        }
      }
    }
  }
`

export const GET_ALL_USER_HEADER_MENU_ITEMS = gql`
  query AllUserHeaderMenuItems($orderBy: String, $isVisible: Boolean, $partnerSlug: String) {
    allUserHeaderMenuItems(orderBy: $orderBy, isVisible: $isVisible, partnerSlug: $partnerSlug) {
      edges {
        node {
          id
          pk
          name
          path
          position
          isVisible
        }
      }
    }
  }
`

export const GET_ALL_MAIN_HEADER_MENU_ITEMS = gql`
  query AllMainHeaderMenuItems($orderBy: String, $isVisible: Boolean, $partnerSlug: String) {
    allMainHeaderMenuItems(orderBy: $orderBy, isVisible: $isVisible, partnerSlug: $partnerSlug) {
      edges {
        node {
          id
          pk
          name
          path
          position
          isVisible
        }
      }
    }
  }
`

export const PROTECHT_TERMS_AND_CONDITIONS = gql`
  query ProtechtTermsAndConditions {
    protechtTermsAndConditions
  }
`

export const GET_VENUE_BY_SLUG = gql`
  query GetVenueBySlug($slug: String!) {
    venue(slug: $slug, status: "public") {
      id
      id
      pk
      name
      slug
      city
      state
      lat
      lon
      zip
      country
      status
      venuePhoto {
        path
        extension
      }
      streetAddress
      description
    }
  }
`

export const ACTIVE_MARKETING_EVENTS = `{
   marketingEvents(status: "public") {
    edges {
       node {
        id
        slug
        }
       }
      }
    }
`
export const GET_PACKAGE_BY_ID = gql`
  query GetPackageById($id: ID!) {
    package(id: $id) {
      id
      pk
      name
      shortDescription
      longDescription
      minSplit
      maxSplit
      price
      quantity
      deliveryNotes
      availableQuantity
      image {
        id
        path
        extension
      }
    }
  }
`
export const getInstagramPostsQuery = gql`
  query GetInstagramPosts {
    instagramPosts {
      id
      mediaType
      mediaUrl
      thumbnailUrl
      shortcode
      permalink
    }
  }
`
export const GET_MARKETING_EVENTS_NEW = gql`
  query getMarketingEventsNew($isActive: Boolean) {
    marketingEvents(status: "public") {
      edges {
        node {
          title
          id
          slug
          template {
            about {
              title
              description
              bannerImageUrl
            }
            hero {
              description
              mobileImageUrl
            }
          }

          artworks(isActive: $isActive, featuredDate_Isnull: false) {
            edges {
              node {
                id
              }
            }
          }
        }
      }
    }
  }
`
export const GET_CURRENT_BID_DETAILS = gql`
  query GetCurrentBidDetails($pk: Int!) {
    findArtwork(pk: $pk) {
      id
      title
      subTitle
      primaryImage {
        extension
        path
      }
    }
  }
`
export const LOCAL_PRICE_QUERY = gql`
  query GetLocalPrice($price: Float!) {
    localPrice(price: $price) {
      price
      currency
    }
  }
`
export const GET_AVAILABLE_CREDIT = gql`
  query GetAvailableCredit {
    currentUser {
      id
      credit
    }
  }
`
